var productName = 'grid';// region Symlinks ("grunt symlink" task)
export * from './webpack.core.entry.thin.js';
// endregion
// region Thin bundle
export * from './webpack.entry.thin.js';
// endregion
